import { ref } from 'vue';

/**
 * Composable for managing modal state
 * Usage in component:
 * const { isOpen, open, close } = useModal();
 */
export function useModal(initialState = false) {
  const isOpen = ref(initialState);

  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  return {
    isOpen,
    open,
    close,
    toggle
  };
}

/**
 * Global modal manager for legacy $modal.show/hide pattern
 * This provides a transition helper while migrating to Composition API
 */
class ModalManager {
  constructor() {
    this.modals = new Map();
  }

  register(name, callbacks) {
    this.modals.set(name, callbacks);
  }

  unregister(name) {
    this.modals.delete(name);
  }

  show(name, params) {
    const modal = this.modals.get(name);
    if (modal && modal.show) {
      modal.show(params);
    }
  }

  hide(name) {
    const modal = this.modals.get(name);
    if (modal && modal.hide) {
      modal.hide();
    }
  }
}

export const modalManager = new ModalManager();

/**
 * Vue 3 plugin to add $modal global property
 * This maintains compatibility with old $modal.show/hide calls
 */
export const ModalPlugin = {
  install(app) {
    app.config.globalProperties.$modal = modalManager;
  }
};
